import { normalizeUserSafeApiError } from "../api/apiErrorNormalizer.js";

export function runtimeErrorMessage(error: unknown): string | null {
  if (error === null || error === undefined) return null;
  return normalizeUserSafeApiError(error).userMessage || "The CMTS request could not be completed.";
}

export function firstRuntimeErrorMessage(...errors: readonly unknown[]): string | null {
  for (const error of errors) {
    const message = runtimeErrorMessage(error);
    if (message) return message;
  }
  return null;
}
